<template lang="html">
    <!-- <div class="flex-col diagnosticDetail-container"> -->
    <div class="">
        <div class="breadCrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.group')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('message.groupManage')}}</el-breadcrumb-item>
				<el-breadcrumb-item>{{$t('message.groupTerminal')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="diagnostic-table verifone-panel diag-panel">
            <div class="flex-col appManagement-table-main">
                <div class="flex-row diagnostic-title">
                    <div class="item-title"><span class="title-tip">{{$t('message.groupName')}}:&nbsp;&nbsp;&nbsp;{{groupName}}</span></div>
                </div>

				<template>
	                <el-table :data="tableData" style="width: 100%">
	                    <el-table-column prop="sn" :label="$t('message.sn')" :show-overflow-tooltip="true"></el-table-column>
	                    <el-table-column prop="model" :label="$t('message.model')"></el-table-column>
	                    <el-table-column prop="merchantName" :label="$t('message.merchant')" width="300" align="center"></el-table-column>
	                </el-table>
	            </template>

	            <div class="pagination-main">
	                <el-pagination @current-change="handleCurrentChange"
    	                background layout="prev, pager, next"
    	                :current-page="pageNum"
    	                :page-count="pageCount">
    	            </el-pagination>
    	        </div>
            </div>
            <div class="submit-container">
                <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            installApps: [],
            diagnostic: {},
            id: '',
			groupName: '',
			tableData: [],
			pageNum: 1,
			pageCount: 1
        }
    },
    mounted() {
		this.init();
    },
    methods: {
		init() {
			console.log(this.$route.params.name);
			this.groupName = this.$route.params.name;
			this.id = this.$route.params.id;

			this.queryTerminal(1);
		},
        callBack() {
            this.$router.replace('/groupList');
        },
		handleCurrentChange(val) {
			this.queryTerminal(val);
		},
        queryTerminal(val) {
            let obj = {
	                pageNum: val,
					groupId: this.id
	            };

            this.$axios({
                method: 'post',
                url: '/marketplace/group/terminal/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.tableData = response.data.terminalList;
					this.pageCount = response.data.totalPage;
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }
}
</script>

<style lang="css">
.diagnosticDetail-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
}
.diagnostic-table {
    background: #fff;
}
.self-table {
    max-height: 330px;
}
.self-table th,.self-table td {
    padding: 8px 10px;
}
.self-tr {
    background: #f2f2f2;
}
.table-title {
    padding: 15px 0;
}
.self-table-contianer {
    max-height: 30vh;
    overflow:auto;
}
.diagnostic-title {
    justify-content: space-between;
    /* border-bottom:1px solid #819bd3; */
    padding: 10px 0;
}
.title-tip {
    font-weight: bold;
    color: #707071;
}
.diag-panel {
    margin-top: 16px;
}
.appManagement-table-main {
    padding: 0 20px 0 20px;
    background-color: #fff;
}
.pagination-main {
	padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/GroupDetail.vue